export default "__VITE_ASSET__ySQKXjBo__"